export default function Kontakt() {
  return (
    <section className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">Kontakt</h1>
      <p>
        Future Now UG<br />
        Max‑Planck‑Str. 4<br />
        85609 Aschheim<br />
        Deutschland
      </p>
      <p className="mt-4">
        Telefon: +49 89 12345678<br />
        E‑Mail: <a href="mailto:info@future-now.online" className="text-primary-500 hover:underline">
          info@future-now.online
        </a>
      </p>
    </section>
  );
}